import type { GridRenderCellParams } from "@mui/x-data-grid-premium";
import { gridRowGroupingModelSelector, useGridApiContext } from "@mui/x-data-grid-premium";
import {
  getCellForSubtotal,
  getFieldNameFromFooterByDepth,
  getSubtotalLabel,
} from "./utils/tabularGridDataProviderHelper.ts";
import { Typography } from "@mui/material";
import type {
  TabularDataCell,
  TabularRow,
  TabularSubtotalLabelPosition,
} from "../../../../../../../api/types/svTypes.ts";

interface Props {
  params: GridRenderCellParams<TabularRow, TabularDataCell>;
  subtotalLabelPosition: TabularSubtotalLabelPosition;
  subtotalLabelFormatPrefix: string;
  subtotalLabelFormatSuffix: string;
}

export const SingleColumnModeGroupingTotalCell = ({
  params,
  subtotalLabelFormatPrefix,
  subtotalLabelFormatSuffix,
}: Omit<Props, "subtotalLabelPosition">) => {
  const apiRef = useGridApiContext();
  const rowGroupingModel = gridRowGroupingModelSelector(apiRef);
  const fieldName = getFieldNameFromFooterByDepth(rowGroupingModel, params);

  const cell = getCellForSubtotal(apiRef, undefined, rowGroupingModel, fieldName, params);

  if (!cell) {
    return null;
  }

  return (
    <Typography variant="subtitle2" sx={{ ml: `${34 + params.rowNode.depth * 16}px` }}>
      {getSubtotalLabel(cell, subtotalLabelFormatPrefix, subtotalLabelFormatSuffix)}
    </Typography>
  );
};

export default SingleColumnModeGroupingTotalCell;
